(() => {
  const dialog = document.querySelector('[data-variant-quick-view]');
  if (!dialog) return;

  const body = dialog.querySelector('[data-variant-quick-view-body]');
  const sectionId = 'variant-quick-view';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let activeTrigger = null;

  const open = async (trigger) => {
    activeTrigger = trigger;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}products/${trigger.dataset.handle}?sections=${sectionId}`);
      if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);
      const sections = await response.json();
      body.innerHTML = sections[sectionId];
      dialog.showModal();
      document.documentElement.classList.add('variant-quick-view-open');
    } catch (error) {
      window.location.href = trigger.dataset.url;
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  };

  const close = () => {
    if (dialog.open) dialog.close();
  };

  const selectProduct = (handle) => {
    const template = Array.from(body.querySelectorAll('template[data-variant-quick-view-option]')).find(
      (item) => item.dataset.variantQuickViewOption === handle
    );
    if (!template) return;

    const panel = body.querySelector('[data-variant-quick-view-panel]');
    const form = body.querySelector('[data-variant-quick-view-form]');
    const addButton = form.querySelector('.product__submit__add');
    const addText = addButton.querySelector('[data-variant-quick-view-add-text]');
    const available = template.dataset.available === 'true';

    panel.replaceChildren(template.content.cloneNode(true));
    form.querySelector('input[name="id"]').value = template.dataset.variantId;
    form.querySelector('input[name="price"]').value = template.dataset.price;
    addButton.dataset.handle = handle;
    addButton.setAttribute('upsell-products', template.dataset.upsell || '');
    addButton.disabled = !available;
    addText.textContent = available ? 'Add To Cart' : 'Out of Stock';
  };

  const stepQuantity = (step) => {
    const input = body.querySelector('input[name="quantity"]');
    const next = (parseInt(input.value, 10) || 1) + step;
    input.value = Math.max(1, next);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-variant-products-quick-view]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-variant-quick-view-close]')) {
      close();
      return;
    }

    const swatch = event.target.closest('[data-variant-quick-view-swatch]');
    if (swatch) {
      body.querySelectorAll('[data-variant-quick-view-swatch]').forEach((item) => {
        const isSelected = item === swatch;
        item.classList.toggle('is-current', isSelected);
        item.setAttribute('aria-pressed', String(isSelected));
      });
      selectProduct(swatch.value);
      return;
    }

    const stepButton = event.target.closest('[data-variant-quick-view-quantity]');
    if (stepButton) {
      stepQuantity(Number(stepButton.dataset.variantQuickViewQuantity));
      return;
    }

    if (event.target.closest('.product__submit__add')) {
      window.setTimeout(close, 0);
    }
  });


  dialog.addEventListener('submit', (event) => {
    event.preventDefault();
  });

  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('variant-quick-view-open');
    body.replaceChildren();
    if (activeTrigger) activeTrigger.focus();
    activeTrigger = null;
  });
})();
